<template>
  <div class="index_wrap" >
    <div class="title">请选择要转账的人</div>
    <div class="order_search" >
      <van-field placeholder="手机号" class="order_input" v-model="tel" >
        <template #button>
          <van-icon name="search" class="search_icon" @click="handleSearch" />
        </template>
      </van-field>
    </div>

    <div class="community_list" v-if="data" >
      <div class="community_item" >
        <div class="community_head" >
          <img :src="data.headImgUrl" />
          <div class="community_head_right" >
            <div>
              <div class="user_name" >{{ data.nickName }}</div>
              <!--              <div class="vip" ></div>-->
              <img :src="level[data.level]" class="vip" />
            </div>
            <div>
              <div class="user_desc" >手机:{{ data.tel }}</div>
              <div class="user_desc" v-if="data.parentUserNickName" >邀请人: {{ data.parentUserNickName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-empty description="请搜索要转账的人" style="margin: 20px 0 0 0" v-else />

    <div class="confirm_btn" v-if="data" @click="handleSelect" >确认选择</div>

    <van-popup v-model="show">
      <div class="transfer_wrap" >
        <img src="./img/close.png" class="close_icon" @click="show = false" />
        <div class="title" >
          购物车转账
        </div>
        <div class="money_content" >
          <div>当前购物车金额</div>
          <div>
            <span>￥</span> {{ this.toThousands(parseInt(sugarMoney)) }}
          </div>
        </div>
        <div class="transfer_text" v-if="data" >转给：{{ data.nickName }}</div>
        <div class="transfer_input_wrap" >
          <input placeholder="请输入转账金额" class="transfer_input" type="number" v-model="money" />
        </div>

        <div class="confirm_button" @click="handleConfirm" >确定</div>
      </div>
    </van-popup>

  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
import {
  getUserInfoByTel, getUserSugarMoneyInfo,
  transferMoney
} from '@/api/transfer'
import {
  Toast
} from 'vant'
import tourist from "@/views/home/img/tourist.png";
import vip from "@/views/home/img/vip.png";
import shopkeeper from "@/views/home/img/shopkeeper.png";
import ceo from "@/views/home/img/ceo.png";
import partner from "@/views/home/img/partner.png";
export default {
  name: 'transferSelect',
  data() {
    return {
      tel: '',
      storeOrderVoList: [],
      data: null,
      level: {
        "-1": tourist,
        "0" : vip,
        "1" : shopkeeper,
        "2" : ceo,
        "3" : partner
      },
      show: false,
      money: '',
      sugarMoney: 0
    }
  },
  methods: {
    handleConfirm() {
      const { money, sugarMoney, data } = this
      if(parseFloat(money) > parseFloat(sugarMoney)) {
        Toast('转账金额不得大于购物金金额')
        return false
      }

      transferMoney({ money, userId: data.userId }).then(res => {
        if(res.success) {
          Toast('操作成功')
          this.$router.go(-1)
        }else {
          Toast(res.msg)
        }
      })
    },
    handleSelect() {
      this.money = ''
      this.show = true
    },
    handleSearch() {
      const { tel } = this
      if(!tel) {
        Toast('请输入手机号')
        return false
      }

      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/

      if(!reg.test(tel))  {
        Toast('手机号格式不正确')
        return false
      }

      getUserInfoByTel({ tel }).then(res => {
        if(res.success) {
          this.data = res.data
        }else {
          this.data = null
        }
      })
    },
    searchOrder() {

    },
    getUserSugarMoneyInfo() {
      getUserSugarMoneyInfo({}).then(res => {
        if(res.success) {
          this.sugarMoney = res.data.sugarMoney
        }
      })
    }
  },
  mounted() {
    this.getUserSugarMoneyInfo()
  }
}
</script>
